import type { FooterContext } from './footer.types'

import { createContext } from '../utils'

const [FooterProvider, useFooterContext] = createContext<FooterContext>({ isOptional: true })

export { FooterProvider, useFooterContext }
